import React from 'react';
import { Result, Button } from 'antd';
import './app.sass';
const ServiceUnavailable = () => (
    <Result
        style={{ color: 'white' }}
        status="500"
        title="Maintenance mode."
        subTitle="The system is currently under maintenance. Please try again later."
        extra={[
            <Button key="reload" onClick={() => window.location.reload()}>
                Reload
            </Button>,
        ]}
    />
);

export default ServiceUnavailable;
